
import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';
import {
  ApprovalState,
  Group,
  GroupSurveyExtension,
  GroupSurveyExtensionApproval,
  IGroupSurveyExtensionApproval,
  VisitorManagementUiClient,
} from '../../../../backend/backendapi';
import { camelCase } from '../../../../../util';
import { initClient } from '../../../../../api';
import Approval from './Approval.vue';

@Component({
  components: {
    Approval,
  },
})
export default class Approvals extends Vue {
  @Prop({ required: true })
  readonly group!: GroupSurveyExtension;
  @Prop({ default: false })
  readonly hideApprovalStati!: boolean;

  readonly visitorManagementApi = initClient(VisitorManagementUiClient);
  readonly approvalGroups: Group[] = [];

  camelCase = camelCase;
  ApprovalState = ApprovalState;

  async mounted(): Promise<void> {
    await this.reloadApprovingGroups();
  }

  addApproval(): void {
    this.group.approvals.push(GroupSurveyExtensionApproval.fromJS({
      id: crypto.randomUUID(),
      groupSurveyExtensionId: this.group.id,
      approvalState: ApprovalState.Unknown,
    } as IGroupSurveyExtensionApproval));
    this.group.collectiveApprovalState = ApprovalState.Unknown;
  }

  private async reloadApprovingGroups() {
    const groups = await this.visitorManagementApi.getApprovalGroups();
    this.approvalGroups.splice(0);
    this.approvalGroups.push(...groups);
  }

  removeApproval(approval: GroupSurveyExtensionApproval): void {
    const index = this.group.approvals.findIndex(e => e.id === approval.id);
    if (index > -1) {
      this.group.approvals.splice(index, 1);
    }
  }
}
